var map = {
	"./form/index.js": 1200,
	"./info/index.js": 1203
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2748;


//////////////////
// WEBPACK FOOTER
// ./src/components/app/registration/discount \.\/[^\/]+\/index\.jsx?$
// module id = 2748
// module chunks = 0